// extracted by mini-css-extract-plugin
export var linkText = "styles-module--link-text--a3a58";
export var linkWrapper = "styles-module--link-wrapper--d83b6";
export var title = "styles-module--title--57252";